import { Navigate, useSearchParams } from 'react-router-dom';
import { resolveLegacyToolPath } from '@/shared/lib/legacy-tool-route';
import { HomePage } from '@/pages/Home';

// Vercel's edge redirects (vercel.json) already return a real HTTP 308 for
// production `/?tool=...` requests. This client-side fallback exists for
// environments the edge config doesn't cover — local dev (`npm run dev`),
// previews without vercel.json applied, and stale cached HTML — so the
// legacy query links never silently 200 into the homepage.
export function LegacyToolRedirect() {
  const [searchParams] = useSearchParams();
  const tool = searchParams.get('tool');

  if (tool) {
    const destination = resolveLegacyToolPath(tool);
    if (destination !== '/') {
      return <Navigate to={destination} replace />;
    }
  }

  return <HomePage />;
}
